import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=650d6904"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650d6904')) {
      api.createRecord('650d6904', component.options)
    } else {
      api.reload('650d6904', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=650d6904", function () {
      api.rerender('650d6904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Pagination.vue"
export default component.exports